module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-3-80ecc9ef01cdf62dda3dda563d902832.jpg";